import logger from 'utilities/logger';

export interface AiDateFields {
  earliestGrantDate: string | null;
  asOfDate: string | null;
}

/**
 * Parses Python-formatted dict strings into strongly-typed JS objects safely.
 * Non-dict strings bail out without logging; only genuine parse failures of
 * dict-shaped input are reported.
 */
export function parseAiDict<T = Record<string, unknown>>(dictString: string): T | null {
  if (!dictString || typeof dictString !== 'string') {
    return null;
  }
  // Plain dates and other scalars are not dicts — skip without a parse error.
  if (!dictString.trimStart().startsWith('{')) {
    return null;
  }

  try {
    // 1. Convert Python literals to standard JSON syntax
    const jsonable = dictString
      .replaceAll('None', 'null')
      .replaceAll('True', 'true')
      .replaceAll('False', 'false')
      // 2. Convert single quotes to valid JSON double quotes
      .replaceAll('\'', '"');

    return JSON.parse(jsonable) as T;
  } catch (error) {
    // Handle exceptional conditions without crashing the app
    logger.error('Failed to parse AI dictionary string', error);
    return null;
  }
}
